<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-television</v-icon>
        <span>Tarja</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Exibir cronômetro na tarja"
      message="Tem certeza que deseja exibir o cronômetro na tarja?"
      confirm-text="Exibir"
      confirm-color="primary"
      :loading="loading"
      @confirm="confirmExibir"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    id_cronometro: Number,
    isDisabled: Boolean,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    if (this.codProducao) {
      await this.getConfigTarja({ cod_producao: this.codProducao });
      this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
    }
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja_cronometro/getConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "tarja_cronometro/assignTarjaParams",
      getConfigTarja: "tarja_cronometro/getConfigTarjaCronometro",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.setCronometroTarja({
          codProducao: this.codProducao,
          idCronometro: this.id_cronometro,
          isFullScreen: false,
        });
      }
    },
    confirmExibir() {
      this.setCronometroTarja({
        codProducao: this.codProducao,
        idCronometro: this.id_cronometro,
      });
    },
    async setCronometroTarja(value) {
      if (!this.configTarja) {
        this.$toast.warning(
          "Nenhuma configuração de tarja definida! Por favor, crie uma."
        );
        return;
      }
      await apiClient.patch(
        `atualizarFlgIsFullScreenTarjaCronometro/${this.configTarja.id}/${this.codProducao}`,
        {
          flg_is_fullscreen: false,
        }
      );
      this.loading = true;
      this.assignTarjaParams(value);
      localStorage.setItem("tarjaParams", JSON.stringify(value));
      this.$emit("change");
      setTimeout(() => {
        this.loading = false;
        this.showDialog = false;
      }, 250);
    },
  },
  watch: {
    "$store.state.tarja_cronometro.configTarjaCronometro": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
    codProducao: async function (value) {
      await this.getConfigTarja({ cod_producao: value.codProducao });
    },
  },
};
</script>

